import React from "react"
import clsx from "clsx";

export default function Block(props) {
    return <div className={clsx("block", props.className)}>
        <header className={"element-set"}>
            <h2>{props.title ? props.title : null}  {props.subtitle ? <p className={"text-xs margin-0"}>{props.subtitle}</p> : null}</h2>
            {props.buttons}
        </header>
        {props.children}
    </div>
}
